import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/components/layout'
import { hasAuthLogin,doLogout} from '@/utils/auth.js'

Vue.use(Router)

export const constRoutes=[
  {
    path: '/login',
    name: 'login',
    title:'登陆页',
    hasChildren:false,
    component: () => import('@/page/login')
  },
  {
    path: '/userinfo',
    name: 'userinfo',
    title:'用户详情',
    hasChildren:false,
    component: () => import('@/page/userinfo')
  },
  {
    path: '/',
    name: 'index',
    title:'首页',
    icon:'home',
    hasChildren:false,
    isIndex:true,
    component: () => import('@/page/index')
  },
  {
    path: '/order',
    name: 'order',
    title:'订单列表',
    icon:'list2',
    hasChildren:true,
    component: Layout, 
    children:[
      {
        path: '/orderlist',
        name: 'orderlist',
        title:'订货订单',
        icon:'cart',
        component: () => import('@/page/orderlist') 
      },
      {
        path: '/fahuo',
        name: 'fahuo',
        title:'发货订单',
        icon:'truck',
        component: () => import('@/page/fahuo') 
      }/*,
      {
        path: '/orderpay',
        name: 'orderpay',
        title:'订单打款',
        icon:'payout',
        component: () => import('@/page/orderpay') 
      }*/
    ]
  },
  {
    path: '/goods',
    name: 'goods',
    title:'商品管理',
    icon:'goods',
    hasChildren:true,
    component: Layout, 
    children:[
      {
        path: '/addgoods',
        name: 'addgoods',
        icon:'add',
        title:'添加普通商品',
        hasChildren:false,
        component: () => import('@/page/addgoods')
      },
      {
        path: '/goodslist',
        name: 'goodslist',
        title:'普通商品列表',
        icon:'list',
        component: () => import('@/page/goodslist') 
      },
      {
        path: '/adddgoods',
        name: 'adddgoods',
        icon:'add',
        title:'添加直升商品',
        hasChildren:false,
        component: () => import('@/page/adddgoods')
      },
      {
        path: '/dgoodslist',
        name: 'dgoodslist',
        title:'直升商品列表',
        icon:'gift',
        component: () => import('@/page/dgoodslist') 
      }
    ]
  },
  {
    path: '/prizelist',
    name: 'prizelist',
    title:'积分奖励',
    icon:'prize',
    hasChildren:true,
    component: Layout, 
    children:[
      {
        path: '/prizesum',
        name: 'prizesum',
        title:'积分汇总',
        icon:'summary',
        component: () => import('@/page/prizesum') 
      },
      {
        path: '/prizedetail',
        name: 'prizedetail',
        title:'积分明细',
        icon:'list',
        component: () => import('@/page/prizedetail') 
      },
      {
        path: '/sqcheck',
        name: 'sqcheck',
        title:'双亲积分审核',
        icon:'square_check',
        component: () => import('@/page/sqcheck') 
      },
      {
        path: '/fhpointset',
        name: 'fhpointset',
        title:'发货积分设置',
        icon:'truck',
        component: () => import('@/page/fhpointset') 
      },
      {
        path: '/entity',
        name: 'entity',
        title:'实体积分设置',
        icon:'entity',
        component: () => import('@/page/entity') 
      }
    ]
  },
  {
    path: '/user',
    name: 'user',
    title:'会员管理',
    icon:'usericon',
    hasChildren:true,
    component: Layout, 
    children:[
      {
        path: '/userlist',
        name: 'userlist',
        title:'会员列表',
        icon:'list',
        component: () => import('@/page/userlist') 
      },
      {
        path: '/levelup',
        name: 'levelup',
        title:'升级记录',
        icon:'levelup',
        component: () => import('@/page/levelup') 
      },
      {
        path: '/download',
        name: 'download',
        title:'下载中心',
        icon:'download',
        component: () => import('@/page/download') 
      },
      {
        path: '/wevotecheck',
        name: 'wevotecheck',
        title:'投票审核',
        icon:'check',
        component: () => import('@/page/wevotecheck') 
      }
    ]
  },
  {
    path: '/content',
    name: 'content',
    title:'内容管理',
    icon:'shop',
    hasChildren:true,
    component: Layout, 
    children:[
      {
        path: '/addcontent',
        name: 'addcontent',
        title:'添加内容',
        icon:'add',
        component: () => import('@/page/addcontent') 
      },
      {
        path: '/contentlist',
        name: 'contentlist',
        title:'内容列表',
        icon:'list',
        component: () => import('@/page/contentlist') 
      }
    ]
  },
  {
    path: '/train',
    name: 'train',
    title:'培训学堂',
    icon:'school',
    hasChildren:true,
    component: Layout, 
    children:[
      {
        path: '/addtrain',
        name: 'addtrain',
        title:'添加培训',
        icon:'add',
        component: () => import('@/page/addtrain') 
      },
      {
        path: '/trainlist',
        name: 'trainlist',
        title:'培训列表',
        icon:'list',
        component: () => import('@/page/trainlist') 
      }
    ]
  },
  {
    path: '/indexpage',
    name: 'indexpage',
    title:'首页管理',
    icon:'lunbo',
    hasChildren:true,
    component: Layout, 
    children:[
      {
        path: '/addindex',
        name: 'addindex',
        title:'添加元素',
        icon:'add',
        component: () => import('@/page/addindex') 
      },
      {
        path: '/indexlist',
        name: 'indexlist',
        title:'元素列表',
        icon:'list',
        component: () => import('@/page/indexlist') 
      }
    ]
  },
  {
    path: '/managermenu',
    name: 'managermenu',
    title:'设置',
    icon:'setting',
    hasChildren:true,
    component: Layout, 
    children:[
      {
        path: '/manager',
        name: 'manager',
        title:'管理员',
        icon:'power',
        component: () => import('@/page/manager') 
      },
      {
        path: '/sms',
        name: 'sms',
        title:'短信',
        icon:'sms',
        component: () => import('@/page/sms') 
      },
      {
        path: '/spuser',
        name: 'spuser',
        title:'补货限制',
        icon:'add',
        component: () => import('@/page/spuser') 
      }
    ]
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/page/404') 
  },{
      path: '*',
      redirect: '404'
  }
]

const router=new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes:constRoutes
})

router.beforeEach((to, from, next)=>{
      if(hasAuthLogin(to.name)){
          next()
      }else{
          doLogout()
          router.push({name:'login',replace:true}).catch(()=>{})
      }
})

export function goTo(url){
  router.push(url).catch(()=>{}) 
}

export default router
